var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"doubt"},[_c('span',[_vm._v(_vm._s(_vm.$t("helpers.chat.doubt_message")))]),_c('FAQ'),_vm._v(" "+_vm._s(_vm.$t("helpers.chat.problem_not_listed"))+" "),_c('section',{staticClass:"footer"},[_c('Back',{on:{"changeComponent":_vm.setComponent}}),_c('Contact',{on:{"changeComponent":_vm.setComponent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }